import { render, staticRenderFns } from "./HealthCheck45Register.vue?vue&type=template&id=04f875e2&scoped=true&"
import script from "./HealthCheck45Register.vue?vue&type=script&lang=js&"
export * from "./HealthCheck45Register.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck45Register.vue?vue&type=style&index=0&id=04f875e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f875e2",
  null
  
)

export default component.exports